/* eslint-disable no-console */
import { useEffect, useState } from 'react';
import { s3 } from 'Services/AWS/s3';

/** @type {import('Services/AWS/s3').FileObject} */
const defaultValue = {
  key: '',
  prefix: '',
  count: 0,
  files: [],
};

const useDocuments = key => {
  const [documents, setDocuments] = useState(defaultValue);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchDocuments = async providedKey => {
    try {
      setError(null);
      setLoading(true);
      const response = await s3.getListObjects(providedKey || key);
      setDocuments(response);
      return response;
    } catch (caught) {
      console.error('Error fetching documents: ', caught);
      setError(caught);
      return documents;
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (key) {
      fetchDocuments();
    }
  }, [key]);

  return {
    fetchDocuments,
    documents,
    loading,
    error,
  };
};

export default useDocuments;
